module.exports = __webpack_public_path__ + "img/_ico1.839b0024.svg";